// extracted by mini-css-extract-plugin
module.exports = {"modals_item":"HeaderSettingsModal_modals_item__1C12Y","modals_content":"HeaderSettingsModal_modals_content__2Z3C0"};